import { useRef, useEffect, useState } from "react";

export default function useElementInView(options, { once = false } = {}) {
    const ref = useRef(null);
    const [isInView, setIsInView] = useState(false);
    const [hasBeenViewed, setHasBeenViewed] = useState(false);

    useEffect(() => {
        const observer = new window.IntersectionObserver(
            ([entry]) => {
                const inView = entry.isIntersecting;

                if (once) {
                    if (inView && !hasBeenViewed) {
                        setIsInView(true);
                        setHasBeenViewed(true);
                        observer.disconnect();
                    }
                } else {
                    setIsInView(inView);
                }
            },
            options
        );

        if (ref.current) {
            observer.observe(ref.current);
        }

        return () => {
            observer.disconnect();
        };
    }, [options, once, hasBeenViewed]);

    return [ref, isInView];
}